import { render, staticRenderFns } from "./ConvoyUtiList.vue?vue&type=template&id=e42be80e&scoped=true&"
import script from "./ConvoyUtiList.vue?vue&type=script&lang=js&"
export * from "./ConvoyUtiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42be80e",
  null
  
)

export default component.exports